enum RequestAbortSignal {
  ImpressionsReports = 'FOOT_TRAFFIC_IMPRESSIONS_REPORTS',
  VisitsReports = 'FOOT_TRAFFIC_VISITS_REPORTS',
}

export default RequestAbortSignal;
